const SET_ERROR = 'error/SET_ERROR';
type SetError = {
  type: typeof SET_ERROR;
  title: string | null | undefined;
  description: string | null | undefined;
};

export type ErrorAction = SetError;

export type ErrorState = {
  title?: string;
  description?: string;
};

export function setError(title?: string, description?: string): SetError {
  return {
    type: SET_ERROR,
    title: title,
    description: description,
  };
}

const initialState = {};
export default function (state: ErrorState = initialState, action: ErrorAction): ErrorState | null | undefined {
  switch (action.type) {
    case SET_ERROR: {
      const { title, description } = action;

      if (title && description) {
        return { ...state, title: title, description: description };
      }

      return null;
    }
    default:
      return state;
  }
}
